import React, { useContext, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axiosInstance from '../../utils/axiosInstance';
import { AuthContext } from '../../context/AuthContext';
import FlashMessage from '../../utils/FlashMessage';
import { HiLogin } from 'react-icons/hi'; // Icon for the header

const Login = () => {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState('');
  const [type, setType] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axiosInstance.post('/users/login', { email, password });
      console.log("Data", data)
      login(data); 
      setMessage('Login Successful!');
      setType('success');
      setTimeout(() => {
        const decodedToken = JSON.parse(atob(data.token.split('.')[1]));
        if (decodedToken.data.is_admin) {
          navigate('/admin'); // Redirect admins to the dashboard
        } else {
          navigate('/'); // Redirect regular users to the homepage
        }
      }, 1000);

    } catch (error) {
      setMessage(error.response?.data?.message || 'Login failed. Please check your credentials.');
      setType('error');
      console.error('Login failed:', error.response?.data?.message);
    }
  };

  const clearMessage = () => {
    setMessage('');
  };

  return (
    <div className="min-h-screen  flex flex-col justify-center items-center p-4">
      {message && <FlashMessage message={message} type={type} onClose={clearMessage} />}
      
      <div className="w-full max-w-md bg-gray-300 rounded-xl shadow-lg p-8 space-y-6">
        <div className="text-center">
          <HiLogin className="mx-auto h-12 w-12 text-indigo-600" />
          <h2 className="mt-4 text-3xl font-extrabold text-gray-900">
            Welcome Back!
          </h2>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="text-sm font-medium text-gray-700">Email</label>
            <input
              type="email"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>
          <div>
            <div className="flex justify-between">
              <label className="text-sm font-medium text-gray-700">Password</label>
              <a href="#" className="text-sm text-indigo-600 hover:underline">Forgot password?</a>
            </div>
            <input
              type="password"
              className="mt-1 w-full px-4 py-2 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition duration-200"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <button 
            type="submit" 
            className="w-full bg-indigo-600 text-white px-4 py-3 rounded-lg font-semibold text-lg hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 transition-colors duration-300"
          >
            Log In
          </button>
        </form>

        <p className="text-center text-sm text-gray-600">
          Don't have an account?{' '}
          <Link to="/register" className="font-medium text-indigo-600 hover:text-indigo-500">
            Sign up now
          </Link>
        </p>
      </div>
    </div>
  );
};

export default Login;